// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
// @ commons
const { OKTable } = require('commonsComponents/OKTable');
// @ helpers
const { getDetailsKit } = require('utilities/securityKit/securityKitHelper');
// @ components
const { SecurityKitRow } = require('components/myProfile/myProfileSecurityKitChange/securityKitRow/securityKitRow')

class KitsResume extends React.PureComponent {

	constructor(props) {
		super(props);
	}

	renderSets() {
		const { sets, referenceKits} = this.props
		const output =  sets.map((set, i) => {
			const details = getDetailsKit(set, referenceKits)
			return (
    <SecurityKitRow
        key={i}
        title={details.title}
        kit={{ amount: details.amountKit, type: details.typeKit }}
        showAmount={details.showAmount}
		/>
			)
		})

		return output
	}

	render() {
		return(
    <OKTable>
        <tbody>
            {this.renderSets()}
        </tbody>
    </OKTable>
    )
	}
}

KitsResume.propTypes = {
	sets: PropTypes.object.isRequired,
	referenceKits: PropTypes.object.isRequired,
}

module.exports.constructor = KitsResume
module.exports.KitsResume = KitsResume
